import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App'
import * as serviceWorker from './serviceWorker';
import reducers from './reducers'
import { createBrowserHistory } from 'history'
import { createStore } from 'redux'

const history = createBrowserHistory();
const store = createStore(reducers);
ReactDOM.render(<><div className="background-gradient-linear"></div><App store={store} history={history}/></>, document.getElementById('root'))
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
